<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import { fade, fly } from 'svelte/transition';
    import { t } from '../stores/locale';
    import Button from './forms/Button.svelte';

    export let open = false;

    const dispatch = createEventDispatcher();

    function close() {
        open = false;
        dispatch('close');
    }

    function handleKeydown(e: KeyboardEvent) {
        if (open && e.key === 'Escape') close();
    }
</script>

<svelte:window on:keydown={handleKeydown}/>

{#if open}
    <!-- svelte-ignore a11y-click-events-have-key-events a11y-no-static-element-interactions -->
    <div class="modal-backdrop" on:click={close} transition:fade={{ duration: 200 }}>
        <!-- svelte-ignore a11y-click-events-have-key-events a11y-no-static-element-interactions -->
        <div class="modal-content" on:click|stopPropagation transition:fly={{ y: 50, duration: 300 }} role="dialog" aria-modal="true">
            <div class="modal-header">
                <h2>About</h2>
                <Button variant="close" on:click={close} aria-label="Close modal">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </Button>
            </div>
            
            <div class="modal-body">
                <div class="about-section">
                    <h3>Listmod HU UI</h3>
                    <p>Version: 0.0.1-DEV</p>
                    <p>&copy; 2026 Listec GmbH</p>
                </div>

                <div class="about-section">
                    <h4>Libraries & Licenses</h4>
                    <ul>
                        <li>Svelte (MIT)</li>
                        <li>Svelte SPA Router (MIT)</li>
                        <!-- Add other major dependencies here -->
                    </ul>
                </div>
            </div>

            <div class="modal-footer">
                <Button on:click={close}>Close</Button>
            </div>
        </div>
    </div>
{/if}

<style lang="scss">
    .modal-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
        backdrop-filter: blur(2px);
    }

    .modal-content {
        background-color: $color-bg-secondary;
        border-radius: 16px; // Modern radius
        width: 90%;
        max-width: 500px;
        max-height: 90vh;
        display: flex;
        flex-direction: column;
    }

    .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1.5rem;
        border-bottom: none; // No border

        h2 {
            margin: 0;
            font-size: 1.25rem;
        }
    }

    .modal-body {
        padding: 1.5rem;
        overflow-y: auto;
    }

    .about-section {
        margin-bottom: 1.5rem;

        &:last-child {
            margin-bottom: 0;
        }

        h3 {
            margin-top: 0;
            margin-bottom: 0.5rem;
        }

        h4 {
            margin-bottom: 0.5rem;
        }

        ul {
            padding-left: 1.2rem;
            margin: 0;
        }
    }

    .modal-footer {
        padding: 1rem 1.5rem;
        border-top: none; // No border
        display: flex;
        justify-content: flex-end;
    }
</style>